import { render, staticRenderFns } from "./myCollect.vue?vue&type=template&id=cb80fc66&scoped=true&"
import script from "./myCollect.vue?vue&type=script&lang=js&"
export * from "./myCollect.vue?vue&type=script&lang=js&"
import style0 from "./myCollect.vue?vue&type=style&index=0&id=cb80fc66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb80fc66",
  null
  
)

export default component.exports